import React, {Fragment, useState}  from "react";
import { Card, Button } from '@material-tailwind/react';
import { SeatsVerticalPanel } from './FilterComponents/SeatsVerticalPanel';
import { CutoffsVerticalPanel } from "./FilterComponents/CutoffsVerticalPanel";
import { HorizontalFilterPanel} from "./FilterComponents/FilterPanel_Horizontal";
import FilterCollapse from "../../../assets/images/FilterCollapse.svg";

export function FilterButton(props) {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen((cur) => !cur);
  };
  
  if (open === true ) {
    return (
      <Fragment>
        <Card className="flex ml-2 border-[1px] border-primary-500 bg-white min-w-100">
          <button onClick={toggleOpen} className="flex flex-row mb-1 mr-2 items-center justify-between ">
            <span className="text-start font-bold text-blue-900 m-1">{"Filters"}</span>
            <img src={FilterCollapse} alt="React Logo" className="flex h-4 m-1" />
          </button>
            <VerticalSearchForm className="flex w-full h-auto rounded-none border-0" optionType={props.optionType}/>
        </Card>
      </Fragment>
    );
  } else {
    return (
      <Button
        variant="outlined"
        color="teal"
        onClick={toggleOpen}
        id="searchButton"
        className="flex flex-col m-0 p-0 h-auto w-6 bg-transparent text-secondary-900 text-xs font-bold justify-items-stretch justify-between"
      >
        <span className="justify-self-stretch m-1">{">>"}</span>
        <span className="justify-self-stretch align-middle -rotate-90 normal-case whitespace-nowrap tracking-[0.2em] -m-12 p-0">{"..Filter Panel.."}</span>
        <span className="justify-self-stretch m-1">{">>"}</span>
      </Button>
    );
  }
      
}
  
export function HorizontalSearchForm(props) {
  return (
    <Fragment>
      <Card className="flex flex-row justify-start items-center align-middle m-0 border-[1px] border-orange-500 bg-orange-50">
        <HorizontalFilterPanel className="flex w-full h-6 text-2xs" optionType={props.optionType}/>
      </Card>
    </Fragment>
  );
}

export function VerticalSearchForm(props) {
  return (
    <Fragment>
        <Card className="flex flex-col justify-center items-center align-middle m-0 rounded-none border-t border-primary-500 bg-white">
        {props.optionType === 'seats'? (
          <SeatsVerticalPanel className="flex m-0"/>
        ): props.optionType === 'cutoffs' ? (
          <CutoffsVerticalPanel className="flex m-0"/>
        ): <div>{''}</div>
        }
        </Card>
    </Fragment>
  );
}
